export default "__VITE_ASSET__ZeTKmVHt__"